let axisColor = '#104881';
let textColor = '#1D62C4';
let legendHeight = 3;

if (window._screenType === '2160') {
    axisColor = '#2D5AA0';
    textColor = '#3266B5';
    legendHeight = 2;
}
let ecStackAreaChart = ({ echarts, dom, data }) => {
    // 数据处理与准备
    let duration = 1000;
    data.dateArr = data.date.map((item, index) => {
        let year = item.slice(0, 4);
        let week = item.slice(4, 6);

        let isFirst = index === 0;
        let isLast = index === data.date.length - 1;
        let space = ' '.repeat(15);
        let str = `${year}.week${week}`;
        if (isFirst) {
            return space + str;
        }
        if (isLast) {
            return str + space;
        }
        return str;
    });

    // 销毁事件
    ecStackAreaChart.destroy = () => {
        echarts.dispose(dom);
        window.removeEventListener('resize', resizeChartStackArea);
    };

    let myChart = echarts.init(dom);
    function resizeChartStackArea() {
        if (myChart) {
            myChart.resize();
        }
    }
    window.addEventListener('resize', resizeChartStackArea);
    let scale = window._scale || 1;

    // 指定图表的配置项和数据
    let option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                label: {
                    backgroundColor: '#6a7985'
                }
            },
            textStyle: {
                fontSize: scale * 14
            },
            formatter: (params, ticket) => {
                let label = params[0].axisValueLabel;
                // label = label.replace('W.', '第') + '周';
                let tpl = label + '<br/>';
                params.forEach(item => {
                    tpl += `${item.seriesName}: ${item.data}%<br/>`;
                });
                return tpl;
            }
        },
        legend: {
            top: 0,
            right: 30,
            itemWidth: 15 * scale,
            itemHeight: legendHeight * scale,
            textStyle: {
                // color: '#FFFFDF',
                color: textColor,
                // fontSize: 30
                fontSize: scale * 12
            },
            data: [
                {
                    name: data.pos.tip,
                    icon: 'rect',
                },
                {
                    name: data.neg.tip,
                    icon: 'rect',
                }
            ]
        },
        color: ['#B99900', '#00C1DE'],
        grid: {
            top: 25,
            left: 30,
            right: 40,
            bottom: 0,
            containLabel: true
        },
        xAxis: [{
            type: 'category',
            boundaryGap: false,
            data: data.dateArr,
            // min: function(value) {
            //     console.error(value);
            //     return value.min - 60*60*1000;
            // },
            // max: function(value) {
            //     console.error(value);
            //     return value.max + 60*60*1000;
            // },
            // nameGap: 100,
            axisLine: {
                lineStyle: {
                    color: axisColor,
                    width: 1
                }
            },
            axisTick: {
                show: false,
                length: 2
            },
            axisLabel: {
                color: textColor,
                interval: data.dateArr.length - 2, // 只显示头和尾，可将间隔设置为data.length - 2
                margin: 8 * scale,
                fontSize: scale * 12
            },
            splitLine: {
                show: false
            },
        }],
        yAxis: [{
            type: 'value',
            offset: 1,
            interval: 25,
            // nameLocation: 'end',
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisColor,
                    width: 1
                }
            },
            axisTick: {
                show: false,
                lineStyle: {
                    color: '#154287',
                    width: 1
                }
            },
            axisLabel: {
                // formatter: '{value}',
                color: textColor,
                margin: 8 * scale,
                verticalAlign: 'middle',
                fontSize: scale * 12,
                formatter: (value, index) => {
                    if (index % 2 === 0) {
                        return value;
                    }
                    return '';
                }
            },
            splitLine: {
                lineStyle: {
                    color: '#0E3675',
                    type: 'dashed',
                    width: 0.8,

                }
            }
        }],
        series: [{
            animationDuration: duration,
            name: data.pos.tip,
            type: 'line',
            // stack: '总量',
            smooth: true,
            showSymbol: false,
            lineStyle: {
                color: '#B99900',
                // fixme 偶现折线图黑边bug,可能是由于shadow绘制bug导致,先注释掉观测一段时间
                // shadowColor: 'rgba(0,0,0,0.50)',
                // shadowBlur: 4,
                width: 2.5,
            },
            data: data.pos
        },
        {
            animationDelay: duration,
            animationDuration: duration,
            name: data.neg.tip,
            type: 'line',
            // stack: '总量',
            smooth: true,
            showSymbol: false,
            lineStyle: {
                color: '#00C1DE',
                // fixme 偶现折线图黑边bug,可能是由于shadow绘制bug导致,先注释掉观测一段时间
                // shadowColor: 'rgba(0,0,0,0.50)',
                // shadowBlur: 4,
                width: 2.5,
            },
            data: data.neg
        }
        ]
    };
    if (window._screenType === '2160') {
        option.grid.left = 40;
        option.color = ['#D6B30D', '#00C1DE'];
        option.series[0].lineStyle.color = '#D6B30D';
        option.series[0].lineStyle.width = 3;
        option.series[1].lineStyle.width = 3;
        option.yAxis[0].splitLine.lineStyle.color = '#0D2F66';
        option.yAxis[0].splitLine.lineStyle.width = 1;
    }
    myChart.setOption(option);
    return ecStackAreaChart;
};

export default ecStackAreaChart;
